import angular from 'angular';
import SidenavComponent from './sidenav.component';

const sidenavModule = angular.module('tinaba.common.sidenav', [])

.component('sidenav', SidenavComponent);

export default sidenavModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/sidenav/sidenav.js
 **/